import {
    flexRender,
    getCoreRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    useReactTable,
  } from "@tanstack/react-table";
  import React, { useEffect, useState } from "react";
  import cssCustom from './CustomCss/Customcss.module.css'
  const BasicTable=({ data, columns })=> {
    const [sorting, setSorting] = useState([]);
    const [filtering, setFiltering] = useState("");
  
    const table = useReactTable({
      data,
      columns,
      getCoreRowModel: getCoreRowModel(),
      getPaginationRowModel: getPaginationRowModel(),
      getSortedRowModel: getSortedRowModel(),
      getFilteredRowModel: getFilteredRowModel(),
      state: {
        sorting: sorting,
        globalFilter: filtering,
      },
      onSortingChange: setSorting,
      onGlobalFilterChange: setFiltering,
     
    });
   

    return (
      <>
    
          <table className={`table ${cssCustom.tableBordered}`} style={{maxWidth:"70%"}}>
            <thead style={{ backgroundColor: "#b0ff45",border:"1px solid black" }}>
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id} data-test="table-row">
                  {headerGroup.headers.map((header) => (
                    <th
                      key={header.id}
                      onClick={header.column.getToggleSortingHandler()}
                      style={{width:"100px"}}
                    >
                      {header.isPlaceholder ? null : (
                        <div
                          style={{
                            justifyContent: "center",
                            cursor: "pointer",
                            textAlign: "center",
                            fontWeight: "bold"
                          }}
                        >
                          {flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                          {{ asc: "▲", desc: "▼ " }[header.column.getIsSorted()]}
                        </div>
                      )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
  
            <tbody>
              {table.getRowModel().rows.map((row) => (
                <tr
                  key={row.id}
                  data-test="row-scene"
                  style={{
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  {row.getVisibleCells().map((cell) => (
                    <td key={cell.id}>
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
      </>
    );
  }
  
  export default BasicTable